// extracted by mini-css-extract-plugin
export var background = "main-layout-module--background--f2035";
export var container = "main-layout-module--container--e2856";
export var header = "main-layout-module--header--8add4";
export var left = "main-layout-module--left--21be9";
export var logo = "main-layout-module--logo--ce806";
export var logo_path = "main-layout-module--logo_path--8243b";
export var right = "main-layout-module--right--05dfb";